import { useEffect, useState } from 'react';

// Specs from the Izenu ad sheet ("Banner na App Izenu"). The recommended values are
// guidance; the hard limits are what the upload handlers in Ads.js reject.
export const AD_SPECS = {
    banner:  { name: 'Banner principal',   width: 1200, height: 600 },
    home:    { name: 'Banner secundário',  width: 640,  height: 200 },
    player:  { name: 'Banner mini play',   width: 640,  height: 100 },
    artwork: { name: 'Capa Play',          width: 600,  height: 600 },
};

const IMAGE_MAX_KB = 150;
const AUDIO_MAX_KB = 500;
const AUDIO_MAX_SEC = 30;

const kb = (bytes) => Math.round(bytes / 1024);

export function Check({ ok, children }) {
    return <span className={ok ? 'text-green-600' : 'text-amber-600'}>{ok ? '✓' : '⚠'} {children}</span>;
}

// Reads the pixel size of a chosen image file ({ w, h }, or null until loaded).
export function useImageSize(file) {
    const [dims, setDims] = useState(null);
    useEffect(() => {
        setDims(null);
        if (!file) return undefined;
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => setDims({ w: img.naturalWidth, h: img.naturalHeight });
        img.src = url;
        return () => URL.revokeObjectURL(url);
    }, [file]);
    return dims;
}

// Legend for an image ad upload, plus a check of the chosen file against it.
export function AdSpecHint({ type, file }) {
    const spec = AD_SPECS[type];
    const dims = useImageSize(file);

    const ratioOk = dims && Math.abs(dims.w / dims.h - spec.width / spec.height) < 0.02;

    return (
        <div className="mt-1 text-xs text-gray-500 space-y-1">
            <div>
                <span className="font-semibold text-gray-700">{spec.name}: {spec.width}×{spec.height} px</span>
                {' · '}JPEG · ideal até {IMAGE_MAX_KB} KB
            </div>
            <div>Aceite: JPG ou PNG até 3 MB.</div>
            {file && (
                <div className="flex flex-wrap gap-x-3">
                    {dims && (
                        <Check ok={ratioOk}>
                            {dims.w}×{dims.h} px{ratioOk ? '' : ` — proporção diferente de ${spec.width}×${spec.height}, vai ser cortada ou esticada`}
                        </Check>
                    )}
                    <Check ok={kb(file.size) <= IMAGE_MAX_KB}>
                        {kb(file.size)} KB{kb(file.size) > IMAGE_MAX_KB ? ' — acima do ideal' : ''}
                    </Check>
                    {file.type !== 'image/jpeg' && <Check ok={false}>PNG — o JPEG é mais leve</Check>}
                </div>
            )}
        </div>
    );
}

// Legend for an audio ad upload. durationSec comes from Ads.js, which already reads it.
export function AudioSpecHint({ file, durationSec }) {
    return (
        <div className="mt-1 text-xs text-gray-500 space-y-1">
            <div>
                <span className="font-semibold text-gray-700">MP3 · máximo {AUDIO_MAX_SEC} segundos · até {AUDIO_MAX_KB} KB</span>
            </div>
            {file && (
                <div className="flex flex-wrap gap-x-3">
                    {durationSec > 0 && (
                        <Check ok={durationSec <= AUDIO_MAX_SEC}>
                            {durationSec}s{durationSec > AUDIO_MAX_SEC ? ' — acima do máximo' : ''}
                        </Check>
                    )}
                    <Check ok={kb(file.size) <= AUDIO_MAX_KB}>
                        {kb(file.size)} KB{kb(file.size) > AUDIO_MAX_KB ? ' — acima do máximo' : ''}
                    </Check>
                </div>
            )}
        </div>
    );
}
